@if (facade.orderActions(); as actions) {
  <div class="next-action-card">
    <h2 class="next-action-card__title">
      {{ 'staff.orders.cockpit.nextActionTitle' | translate }}
    </h2>

    @if (actions.cockpitPrimaryAction; as primary) {
      <p class="next-action-card__summary">
        {{ 'staff.orders.cockpit.nextActionSummary' | translate }}
      </p>

      @if (primary.available) {
        <lib-cabinet-button
          class="next-action-card__btn"
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="primary.labelKey | translate"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          [isLoading]="facade.saving()"
          (actionEvent)="onPrimaryAction()"
        />
      } @else {
        <div class="next-action-card__blocked">
          <span class="next-action-card__blocked-label">{{
            primary.labelKey | translate
          }}</span>
          @if (primary.blockedHintKey) {
            <p class="next-action-card__hint">
              {{ primary.blockedHintKey | translate }}
            </p>
          }
        </div>
      }
    } @else {
      <p class="next-action-card__idle">
        {{ 'staff.orders.cockpit.nextActionIdle' | translate }}
      </p>
    }

    @if (cancelAction(); as cancel) {
      <button
        type="button"
        class="next-action-card__cancel"
        [disabled]="facade.saving() || !cancel.available"
        (click)="onSecondaryAction(cancel.id)"
      >
        {{ cancel.labelKey | translate }}
      </button>
    }

    @if (
      facade.isWarehouseWorker() &&
      facade.row()?.status === 'in_transit' &&
      !facade.row()?.warehouse_id
    ) {
      <p class="next-action-card__hint">
        {{ 'admin.storageRequests.receiveNoWarehouse' | translate }}
      </p>
    }
  </div>
}
